/** The permission keys Admin gates on (the catalogue in platform-php `Permissions`; the services enforce). */
export const P = {
    queuesRead: 'admin.queues.read',
    casesRead: 'admin.cases.read',
    casesAssign: 'admin.cases.assign',
    casesWrite: 'admin.cases.write',
    auditRead: 'admin.audit.read',
    search: 'admin.search',
    policiesPublish: 'admin.policies.publish',
    flagsManage: 'admin.flags.manage',
    flagsKillSwitch: 'admin.flags.kill_switch',
    approvalsRead: 'admin.approvals.read',
    approvalRulesManage: 'admin.approval_rules.manage', // BM-105

    alertsRead: 'reporting.alerts.read',
    /** BM-122: the finance report's processing cost and margin (granted to no role by default). */
    financeRead: 'reporting.finance.read',
    /** BM-122: the metrics page and the home's Today strip. */
    reportsRead: 'reporting.staff.read',
    alertsAck: 'admin.alerts.ack',
    httpLogsRead: 'platform.http_logs.read',
    merchantsRead: 'identity.merchants.read',
    // BM-93: the hierarchy lifecycles; impersonation is granted per person (decision 13)
    organizationsManage: 'identity.organizations.manage',
    storesReview: 'identity.stores.review',
    usersManage: 'identity.users.manage',
    usersImpersonate: 'identity.users.impersonate',
    merchantsApprove: 'identity.merchants.approve',
    merchantsSuspend: 'identity.merchants.suspend',
    merchantUpdate: 'identity.merchant.update',
    onboardingReview: 'identity.onboarding.review',
    staffManage: 'identity.staff.manage',
    rolesManage: 'identity.roles.manage',
    tenantsManage: 'identity.tenants.manage',
    chargesRead: 'payments.charges.read',
    /** BM-84 Q5: capture and void an authorized charge (Ops, Finance). */
    chargesManage: 'payments.charges.manage',
    refundsIssue: 'payments.refunds.issue',
    reviewsDecide: 'payments.reviews.decide',
    systemsManage: 'payments.systems.manage',
    // BM-63: the tax provider transactions and the tenant's tax codes
    taxRead: 'payments.tax.read',
    taxManage: 'payments.tax.manage',
    /** BM-145: re-queue a Ledger delivery Ledger refused (the Alerts queue's Retry). */
    ledgerManage: 'payments.ledger.manage',
    taxCodesManage: 'catalogue.tax_codes.manage',
    // BM-62: the Pricing module
    pricingRead: 'pricing.read',
    pricingManage: 'pricing.manage',
    pricingAssign: 'pricing.assign',
    binImport: 'pricing.bin_ranges.import',
    disputesRead: 'risk.disputes.read',
    disputesRespond: 'risk.disputes.respond',
    // BM-125: the risk engine (rules, profiles, lists, screening feeds, holds), granted per person
    riskRulesRead: 'risk.rules.read',
    riskRulesManage: 'risk.rules.manage',
    riskProfilesManage: 'risk.profiles.manage',
    riskListsManage: 'risk.lists.manage',
    riskScreeningManage: 'risk.screening.manage',
    // BM-125 slice 4: the tenant's sanctions screening (cases, whitelist, merchant subjects, index status)
    riskScreeningDecide: 'risk.screening.decide',
    // BM-125 slice 2: the review queue (assign, note, approve, decline, bypass)
    riskReviewsDecide: 'risk.reviews.decide',
    // BM-125 slice 3: merchant monitoring and the Risk dashboard, proposing and lifting measures, approving them
    riskMonitoringRead: 'risk.monitoring.read',
    riskMeasuresPropose: 'risk.measures.propose',
    riskMeasuresApprove: 'risk.measures.approve',
    // BM-125 slice 5 (decision 45): the Models page
    riskModelsManage: 'risk.models.manage',
    buyersFlag: 'risk.buyers.flag',
    notificationsRead: 'delivery.notifications.read',
    templatesManage: 'delivery.templates.manage',
    /** bm-147 § 7 (D-16): merchant webhook endpoints and deliveries, and the deliveries panel on object pages. */
    webhooksManage: 'delivery.webhooks.manage',
    merchantSettingsManage: 'billing.merchant_settings.manage',
    // BM-70 § 12-13 (D-23): the admin test console and its per-staff allow-list
    consoleUse: 'checkout.console.use',
    /** bm-111 § 10: the Sessions list and session page (every staff role holds it). */
    sessionsRead: 'checkout.sessions.read',
    /** bm-147 § 1: the Orders list (the staff orders routes' permission). */
    ordersRead: 'checkout.orders.read',
    /** bm-147 § 3: Resend receipt on the order page (the staff receipt route's permission). */
    ordersReissue: 'checkout.orders.reissue',
    /** bm-147 § 5: the Subscriptions list and page (the staff subscriptions read routes' permission). */
    subscriptionsRead: 'billing.subscriptions.read',
    /** bm-147 § 5: cancel, retry and send card-update link on the subscription page. */
    subscriptionsManage: 'billing.subscriptions.manage',
    consoleAllowListManage: 'checkout.console_allow_list.manage',
} as const;
